<template>
  <div>
    <checkbox-component
      :id="name"
      @checkbox:change="onChange"
      class="align-items-start news-checkbox"
    >
      <p>
        {{ $t('Receive news', {name: channelName}) }}
      </p>
    </checkbox-component>
  </div>
</template>

<script>
import CheckboxComponent from './CheckboxComponent';
import {mapState} from 'vuex';

export default {
  name: 'NewsCheckbox',
  components: {CheckboxComponent},
  props: {
    name: {
      type: String,
      default: 'news',
    },
  },
  computed: {
    ...mapState({
      channelSettings: (state) => state.channel.settings,
    }),
    channelName() {
      return this.channelSettings?.content?.['contact-title'] || this.channelSettings?.title;
    },
  },
  methods: {
    onChange(e) {
      this.$emit('checkbox:change', {
        name: this.name,
        value: e.target.checked,
      });
    },
  },
};
</script>

<style scoped>
.news-checkbox {
  --checkbox-top-offset: .3rem;
}
</style>
